import React, {
  forwardRef,
  HTMLAttributes,
  PropsWithChildren,
  Ref,
} from "react";

import classnames from "classnames";

import { StyledListItem } from "./Styles";

export interface ListItemProps {
  className?: string;
}

export const ListItem = forwardRef(
  (
    {
      children,
      className,
      ...props
    }: PropsWithChildren<ListItemProps> & HTMLAttributes<HTMLLIElement>,
    ref: Ref<HTMLLIElement> | null | undefined
  ) => {
    return (
      <StyledListItem
        className={classnames("c-list-item", className)}
        ref={ref}
        tabIndex={0}
        {...props}
      >
        {children}
      </StyledListItem>
    );
  }
);

ListItem.displayName = "ListItem";
